import styled, { keyframes } from '@app/styled';
import { color, zIndex } from '@app/theme';

import type { MainSpinnerProps } from './MainSpinner';

const Loading = keyframes`
    0% {
        transform: translateY(100px);
        opacity: 0;
    }
    7% {
        transform: none;
        opacity: 1;
    }
    52% {
        transform: none;
        opacity: 1;
    }
    62% {
        transform: translateY(-500px);
        opacity: 0;
    }
    100% {
        transform: translateY(50px);
        opacity: 0;
    }
`;

export const Backdrop = styled.div<MainSpinnerProps>`
    position: ${({ position }) => position};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: ${zIndex('loadingOverlay')};
    background-color: ${color('custom.surface.primary')};
    opacity: 0.8;
`;

export const Container = styled.div<MainSpinnerProps>`
    position: ${({ position }) => position};
    z-index: ${zIndex('loadingOverlay')};
    top: ${({ spinnerTopPosition }) => (spinnerTopPosition ? `${spinnerTopPosition}px` : '50%')};
    left: 50%;
    transform: ${({ spinnerTopPosition }) => `translate(-50%, ${spinnerTopPosition ? 0 : '-50%'}) scale(0.16)`};
`;

export const Logo = styled.div`
    margin: 0 auto;
    position: relative;
    width: 274px;
`;

export const TopLine = styled.div`
    position: absolute;
    width: 274px;
    height: 49px;
    opacity: 0;
    background: #a4a14a;
    top: 0;
    animation: ${Loading} 3s cubic-bezier(0.3, 0.5, 0.7, 0.5) infinite;
`;

export const MiddleLine = styled.div`
    position: absolute;
    width: 274px;
    height: 49px;
    opacity: 0;
    background: #ffc501;
    top: 97px;
    animation: ${Loading} 3s cubic-bezier(0.3, 0.5, 0.7, 0.5) 0.2s infinite;
`;

export const BottomLine = styled.div`
    position: absolute;
    width: 274px;
    height: 49px;
    opacity: 0;
    top: 194px;
    animation: ${Loading} 3s cubic-bezier(0.3, 0.5, 0.7, 0.5) 0.4s infinite;
`;

export const BottomOne = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    height: 49px;
    width: 90px;
    background: #ff6336;
`;

export const BottomTwo = styled.div`
    position: absolute;
    height: 49px;
    width: 115px;
    background: #ff6336;
    top: -7px;
    left: 73px;
    transform-origin: left center;
    transform: rotate(45deg);
`;

export const BottomThree = styled.div`
    position: absolute;
    height: 49px;
    width: 115px;
    background: #ff6336;
    top: -7px;
    left: auto;
    right: 73px;
    transform-origin: right center;
    transform: rotate(-45deg);
`;

export const BottomFour = styled.div`
    position: absolute;
    top: 0;
    height: 49px;
    width: 90px;
    background: #ff6336;
    left: auto;
    right: 0;
`;
